import {Authenticated} from 'src/router/middlewares'

export default [
    {
        path: '/external-links',
        name: 'externals.index',
        component: () => import('src/pages/externals/index'),
        meta: {
            title: 'Listado de reservas externas',
            middleware: [Authenticated]
        }
    },
]